import Link from 'next/link'
import { Box, styledComponent, Button, Typography } from '@hermes/web-components'

export const HeaderContainer = styledComponent(Box)(({ theme }) => ({
  height: '100%',
  marginLeft: '0',
  gridColumn: 2,
  gridRow: '1 / span 2',
  maxWidth: 'none',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    marginLeft: '100px',
    marginTop: '0',
    maxWidth: '343px'
  }
}))

export const AuthorMarketing = styledComponent(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  backgroundColor: theme.palette.neutral[100],
  borderRadius: '8px',
  margin: '16px 0',
  fontSize: '14px',
  lineHeight: '20px',
  [theme.breakpoints.down('md')]: {
    fontSize: '12px',
    lineHeight: '16px',
    padding: '12px'
  },
  '& > div': {
    display: 'flex',
    alignItems: 'center',
    p: {
      margin: '0 6px'
    }
  }
}))

export const AuthorLink = styledComponent(Link)(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '24px',
  textDecoration: 'none',
  color: theme.palette.neutral[900]
}))

export const BuyButton = styledComponent(Button, {
  shouldForwardProp: (prop) => prop !== 'isUnavailable'
})<{ isUnavailable?: boolean }>(({ isUnavailable }) => ({
  ...(isUnavailable
    ? {
        borderRadius: '8px',
        letterSpacing: '-0.02em',
        height: 'auto',
        padding: '16px 20px',
        fontWeight: 400,
        lineHeight: '24px'
      }
    : {}),
  marginBottom: '16px',
  width: '100%',
  padding: '16px 22px'
}))

export const BuyerActionsContainer = styledComponent(Box)({
  display: 'grid',
  gap: '24px',
  justifyContent: 'start',
  justifyItems: 'start',
  marginTop: '16px'
})

export const BuyerActionButton = styledComponent(Button)(({ theme }) => ({
  display: 'inline-flex',
  gap: '8px',
  fill: theme.palette.primary.main,
  color: theme.palette.primary.main,
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 400
}))

export const RecommendedSellerContainer = styledComponent(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutral[100],
  display: 'flex',
  paddingRight: '12px',
  borderRadius: '12px',
  flexDirection: 'column',
  alignItems: 'stretch',
  marginBottom: '24px'
}))
export const RecommendedSellerTitle = styledComponent(Typography)(({ theme }) => ({
  backgroundColor: theme.palette.tertiary[300],
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 500,
  color: theme.palette.neutral[900],
  padding: '6px 12px',
  borderRadius: '12px 0'
}))
